import { render, staticRenderFns } from "./StepperLabels.vue?vue&type=template&id=5e340c09"
import script from "./StepperLabels.vue?vue&type=script&lang=js"
export * from "./StepperLabels.vue?vue&type=script&lang=js"
import style0 from "./StepperLabels.vue?vue&type=style&index=0&id=5e340c09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports